export type BasemapKey = 'dark' | 'street' | 'satellite';

export interface BasemapDef {
  label:       string;
  url:         string;
  attribution: string;
  maxZoom:     number;
}

export const BASEMAPS: Record<BasemapKey, BasemapDef> = {
  dark: {
    label:       'Dark',
    url:         'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=cb1_2qmv_1_d9995f9ee8117ecb670ce692',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    maxZoom:     19,
  },
  street: {
    label:       'Street',
    url:         'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
    attribution: '&copy; <a href="https://maps.google.com">Google Maps</a>',
    maxZoom:     20,
  },
  satellite: {
    label:       'Satellite',
    url:         'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    attribution: '&copy; <a href="https://maps.google.com">Google Maps</a>',
    maxZoom:     20,
  },
};

/** Compact floating basemap switcher — paste inside a `relative` map wrapper */
export const BASEMAP_ICONS: Record<BasemapKey, string> = {
  dark:      '🌑',
  street:    '🗺️',
  satellite: '🛰️',
};
